import React, { Component } from 'react';

import CommonTruckerLocked from './CommonTruckerLocked';

import PickupOrderModel from '../../../../models/PickupOrder';

interface CommonTruckerLockedContainerProps {
  //  dropOffOrder: PickupOrderModel;
  /*
    * TODO: @Desi. I suggest in future to replace dropOffOrder props with
    * object { locked: value, sealed: value, sealNumber: value } 
    * that handles only these params needed for this common container,
    * because now i need props of type PickupOrderGha and becomes
    * very complicated to handle this. So i did it with any!
    * This container don't need to know about all props of DO or PO. 
  */
  dropOffOrder: any;
  inputFocusChanged?: any;
  setContainerState?: (data: any) => void;
  view: string;
  editable: boolean;
  sealNumberMandatory?: boolean;
};

interface CommonTruckerLockedContainerState {
  openDockOverloadModal: boolean;
  sealNumber: string;
  locked: boolean;
  sealed: boolean;
};

class CommonTruckerLockedContainer extends Component<CommonTruckerLockedContainerProps, CommonTruckerLockedContainerState> {

  state = {
    openDockOverloadModal: false,
    sealNumber: '',
    locked: false,
    sealed: false
  }

  componentDidMount() {
    this.setState({
      locked: Boolean(this.props.dropOffOrder.locked),
      sealed: Boolean(this.props.dropOffOrder.sealed),
      sealNumber: this.props.dropOffOrder.seal_number || ''
    });
  }

  componentDidUpdate(prevProps: CommonTruckerLockedContainerProps) {

    const currProps: CommonTruckerLockedContainerProps = this.props;

    if (currProps.dropOffOrder.locked !== prevProps.dropOffOrder.locked ||
        currProps.dropOffOrder.sealed !== prevProps.dropOffOrder.sealed ||
        currProps.dropOffOrder.seal_number !== prevProps.dropOffOrder.seal_number) {
          this.setState({
            locked: Boolean(currProps.dropOffOrder.locked),
            sealed: Boolean(currProps.dropOffOrder.sealed),
            sealNumber: currProps.dropOffOrder.seal_number || ''
          });
        }
  }

  handleChange = (event: any): void => {

    const value: string = event.target.value;

    const dropOffOrder: PickupOrderModel = { ... this.props.dropOffOrder };

    switch( value ) {

      case 'locked' :

        if ( this.state.sealed ) {
          this.setState({ sealed: false, sealNumber: '' });
          dropOffOrder.sealed = false;
          dropOffOrder.seal_number= '';
        }

        const locked: boolean = !this.state.locked;
        this.setState({ locked });
        dropOffOrder.locked = locked;

        break;
      case 'sealed':

        if (this.state.locked) {
          this.setState({ locked: false });
          dropOffOrder.locked = false;
          dropOffOrder.seal_number= '';
        }

        const sealed: boolean = !this.state.sealed;
        this.setState({ sealed });
        dropOffOrder.sealed = sealed;
        
        break;
      default: break;
    }

    if(this.props.setContainerState) {
        this.props.setContainerState(dropOffOrder);
    }

    if (this.props.inputFocusChanged) {
      this.props.inputFocusChanged(dropOffOrder);
    }

  }

  handleChangeSealNumber = (event: any): void => {
    const sealNumber: string = event.target.value;
    this.setState({ sealNumber });
  }

  handleSetSealNumber = (event: any): void => {

    const dropOffOrder: PickupOrderModel = { ... this.props.dropOffOrder };

    if (this.props.editable && this.props.setContainerState) { 
      dropOffOrder.locked = false;
      dropOffOrder.sealed = true;
      dropOffOrder.seal_number = event.target.value;
      this.props.setContainerState(dropOffOrder);
    }
    
    if (this.props.inputFocusChanged) {
      this.props.inputFocusChanged(dropOffOrder);
    }
  }

  render() {
    return (
      <CommonTruckerLocked
        handleChange={ this.handleChange }
        handleChangeSealNumber={ this.handleChangeSealNumber }
        handleSetSealNumber={ this.handleSetSealNumber }
        sealNumber={ this.state.sealNumber }
        sealNumberMandatory={ this.props.sealNumberMandatory }
        sealed={ this.state.sealed }
        locked={ this.state.locked }
        view={ this.props.view }
        disabled={ !this.props.dropOffOrder.allowed_ops.update_dispatch_driver_details || !this.props.editable}
      />
    );
  };
};

export default CommonTruckerLockedContainer;
